import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { setLanguage, getLanguage } from '../../lib/i18n';

export function Header() {
  const { t } = useTranslation();
  const currentLang = getLanguage();

  const toggleLanguage = () => {
    setLanguage(currentLang === 'en' ? 'ja' : 'en');
  };

  return (
    <header className="border-b border-gray-200 bg-white dark:border-gray-600 dark:bg-black">
      <div className="container-app">
        <div className="flex h-16 items-center justify-between">
          {/* Logo / Site title */}
          <Link
            to="/"
            className="text-lg font-bold text-black no-underline hover:no-underline dark:text-white sm:text-xl"
          >
            {t('site.title')}
          </Link>

          {/* Navigation */}
          <nav className="flex items-center gap-4">
            {/* Desktop nav links */}
            <div className="hidden items-center gap-6 sm:flex">
              <Link
                to="/"
                className="text-sm font-medium text-gray-600 hover:text-accent dark:text-gray-200"
              >
                {t('nav.home')}
              </Link>
              <Link
                to="/vote"
                className="text-sm font-medium text-gray-600 hover:text-accent dark:text-gray-200"
              >
                {t('nav.vote')}
              </Link>
              <Link
                to="/suggest"
                className="text-sm font-medium text-gray-600 hover:text-accent dark:text-gray-200"
              >
                {t('nav.suggest')}
              </Link>
            </div>

            {/* Language switcher */}
            <button
              onClick={toggleLanguage}
              className="flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100 hover:text-accent dark:text-gray-200 dark:hover:bg-gray-900"
              aria-label={t('accessibility.language_switcher')}
            >
              <Globe className="h-4 w-4" aria-hidden="true" />
              <span>{currentLang === 'en' ? '日本語' : 'EN'}</span>
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
}
